import slideTo from './slideTo';
import slideToLoop from './slideToLoop';
import slideNext from './slideNext';
import slidePrev from './slidePrev';
import slideReset from './slideReset';
import slideToClosest from './slideToClosest';
import slideToClickedSlide from './slideToClickedSlide';
export default {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/slide/index.js
// module id = 737
// module chunks = 169